module.exports = __webpack_public_path__ + "media/images/brand-assets/dark_3-800903ad519a9457a8f30dd4a513dd45.png";